module.exports = __webpack_public_path__ + "media/images/batscop-fbc7937f342e3ec1e1a3c9b2363eecd5.gif";